import React from 'react';
import PropTypes from 'prop-types';

import Ad from '@ifeng-fe/ui_pc_ad';
import styles from './index.css';
import { rel } from '@ifeng-fe/ui_rel';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Navigation extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        adInfo: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content, adInfo } = this.props;

        const navigation = content.map((item, index) => (
            <li key={index} className={index === 0 ? styles.pa : ''}>
                <a href={item.url} target="_blank" rel={rel} title={item.title}>
                    {item.title}
                </a>
            </li>
        ));

        return (
            <div id="navigation" className={styles.col_box}>
                <Ad content={adInfo} styleName={styles.box} />
                <div className={styles.col_navlist}>
                    <div className={styles.col_nav}>
                        <ul className="clearfix">
                            {navigation}
                            <li style={{ display: 'none' }}>
                                <a href="https://biz.ifeng.com/" target="_blank" rel={rel} title="品牌主场">
                                    品牌主场
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Navigation);
